// import React from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import ChatMessageInput from 'components/Chat/ChatMessageInput';
import { selectConversationContactDialString, setChatMode } from 'actions/Chat';
import { chatActions, chatSelectors } from '@lifesize/nucleus';
import _get from 'lodash/get';

const mapStateToProps = (state, ownProps) => {
  const formValues = _get(state, 'app.form.chat.values', {});
  const contact = _get(ownProps, 'conversation.contact', {});
  const currentConversation = chatSelectors.getChatForWebGenerator(state)(contact.dialString);
  const participants = (_get(currentConversation, 'participants') || []);
  // TODO: Remove the false && when we want to show chats with only guests.
  const hasOnlyGuests = false && !participants.find(participant => !participant.isGuest) && !!participants.length;

  return {
    formValues,
    hasOnlyGuests
  };
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onMessageSend: (field, values) => {
      const message = values[field];

      // conversation is provided by Parent component

      // setChatMode() sets 'app.chat.conversationMode' defaults to 'current', but also could be 'search' or 'new' it determines the display state of the chat header and window
      dispatch(setChatMode());
      // selects the current chat by dialstring
      dispatch(selectConversationContactDialString(_get(ownProps, 'conversation.contact.dialString')));
      dispatch(chatActions.sendMessage(message, ownProps.chatContact || { uuid: _get(ownProps, 'conversation.conversationId') }));

      // reset the chat field
      dispatch(change('chat', field, ''));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatMessageInput);
